import { typographyStyles, constants, GlobalLayout } from "@newsela/angelou";

const { ui } = constants.colors;
const { unifiedNavsMediaQuery } = GlobalLayout;

const navListCss = {
  margin: 0,
  padding: 0,
  width: "100%",
  "> li": {
    listStyle: "none",
  },
  "@media print": {
    display: "none",
  },
};

export const containerStyle = [
  navListCss,
  {
    display: "grid",
    gridTemplateAreas: '"logo skip alerts closeButton"',
    gridTemplateColumns: "min-content auto 1fr",
    backgroundColor: ui.neutral[700],
    gap: "8px",
    alignItems: "center",
    // TODO: consider moving below into Angelou
    height: 64,
    [unifiedNavsMediaQuery]: {
      gap: "24px",
    },
  },
];

export const viewModeMessageStyle = [
  typographyStyles.textXSObj,
  navListCss,
  {
    gridArea: "alerts",
    color: ui.white[700],
    display: "flex",
    justifyContent: "center",
  },
];

export const iconCss = {
  width: "24px",
  margin: "0 8px",
  path: {
    stroke: ui.white[500],
    ":hover": {
      stroke: ui.neutral[700],
      backgroundColor: ui.white[700],
    },
  },
};

export const assignmentViewButtonStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  backgroundColor: ui.neutral[700],
  ":hover": {
    backgroundColor: ui.white[700],
    color: ui.neutral[700],
    stroke: ui.neutral[700],
  },
};

export const closeButton = [
  navListCss,
  {
    gridArea: "closeButton",
  },
];

export const logoItemCss = {
  width: "32px",
  [unifiedNavsMediaQuery]: {
    width: "initial",
  },
};
